import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

const MetaDialog = ({ open, meta, loading, apiError, onClose, onSave, readOnly = false }) => {
  const [expected, setExpected] = useState("");
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    if (open) {
      setExpected(meta?.expected ?? "");
      setValidationError("");
    }
  }, [open, meta]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (readOnly) return;
    const numericExpected = Number(expected);

    if (!Number.isInteger(numericExpected) || numericExpected <= 0) {
      setValidationError("Ingresa un número entero mayor que cero.");
      return;
    }

    onSave(numericExpected);
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{readOnly ? "Meta de transcripción" : meta?.configured ? "Actualizar meta" : "Definir meta"}</DialogTitle>
        <DialogContent>
          {apiError && <Alert severity="error" sx={{ mb: 2 }}>{apiError}</Alert>}
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label="Cantidad esperada"
            type="number"
            value={expected}
            onChange={(event) => {
              setExpected(event.target.value);
              setValidationError("");
            }}
            inputProps={{ min: 1, step: 1 }}
            error={Boolean(validationError)}
            helperText={validationError || "Cantidad total esperada para esta convocatoria."}
            disabled={loading || readOnly}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>{readOnly ? "Cerrar" : "Cancelar"}</Button>
          {!readOnly && (
            <Button type="submit" variant="contained" disabled={loading}>
              {loading ? "Guardando..." : "Guardar"}
            </Button>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MetaDialog;
